export enum ShippingStatus {
    ShippingNotRequired = 0,
    Pending = 10,
    PreparedToShipped = 15,
    PartiallyShipped = 25,
    Shipped = 30,
    Delivered = 40
}